<div class="skeleton">
  @for (col of skeletonCols; let index = $index; track index) {
    <div class="skeleton__col">
      @for (row of skeletonRows; let index2 = $index; track index2) {
        <div class="group">
          <div class="group__item"></div>
          <div class="group__item--large"></div>
        </div>
      }
    </div>
  }
</div>
